import { ValueFormat } from 'globales-projekt-angular';
import { Ergebnisse } from '../ws/ergebnis/ergebnisse.model';
import { AuspraegungGebaeude } from '../ws/dbKlassen/auspraegung-gebaeude.model';

export class TableFlaecheVolumen {
  modul!: string;
  information!: string;
  wert: (string | null)[] = [];

  public static getTableFlaecheVolumenList(
    ergebnisse: Ergebnisse
  ): TableFlaecheVolumen[] {
    if (ergebnisse.ergebnisGebaeudeList.length == 0) return [];

    let tableFlaecheVolumen: TableFlaecheVolumen[] = [];

    let auspraegungGebaeudeList: AuspraegungGebaeude[] =
      ergebnisse.ergebnisGebaeudeList[0].gebaeude.flaechenVolumen;

    auspraegungGebaeudeList.forEach((entry) => {
      let element: TableFlaecheVolumen = new TableFlaecheVolumen();
      element.modul = entry.modul;
      element.information = entry.information;
 
      ergebnisse.ergebnisGebaeudeList
        .slice(ergebnisse.ergebnisGebaeudeList.length === 1 ? 0 : 1)
        .forEach((entry2) => {
          let found: boolean = false;
          entry2.gebaeude.flaechenVolumen.forEach((entry3) => {
            if (entry3.modul === element.modul) {
              let valueFormat: ValueFormat = new ValueFormat();
              element.wert.push(
                valueFormat.getStringDecimalDimension(
                  entry3.wert,
                  entry3.nachkommastellen,
                  entry3.dimension
                )
              );

              found = true;
            }
          });

          if (!found) element.wert.push(null);
        });



      tableFlaecheVolumen.push(element);
    });

     
    return tableFlaecheVolumen;
  }
}
